<template>
  <div>
    <div>
      <NewsTable />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NewsTable from "@/components/News/NewsTableComponent.vue";

export default {
  name: "ViewNewsList",
  components: {
    NewsTable,
  },
  data() {
    return {};
  },
  computed: {
    username() {
      return this.$store.state.userInfo.userName;
    },
  },
};
</script>
